import { render, staticRenderFns } from "./TeleconsultaOptions.vue?vue&type=template&id=7da4d616&scoped=true&"
import script from "./TeleconsultaOptions.vue?vue&type=script&lang=js&"
export * from "./TeleconsultaOptions.vue?vue&type=script&lang=js&"
import style0 from "./TeleconsultaOptions.vue?vue&type=style&index=0&id=7da4d616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da4d616",
  null
  
)

export default component.exports